<template>
  <b-table
    :data="items"
    :mobile-cards="false"
    narrowed
    sticky-header
    :row-class="rowClass"
    :height="height"
  >
    <b-table-column label="" width="40" centered v-slot="props">
      <b-tooltip v-show="props.row.error" position="is-right">
        <b-icon icon="information" type="is-danger"></b-icon>
        <template v-slot:content>
          {{ props.row.error }}
        </template>
      </b-tooltip>
    </b-table-column>
    <b-table-column
      field="code"
      :label="$t('attributes.product_code')"
      width="100"
      centered
      sortable
      v-slot="props"
    >
      <b-tooltip type="is-light" position="is-right">
        <p>{{ props.row.code }}</p>
        <template v-slot:content>
          <p v-html="props.row.name"></p>
        </template>
      </b-tooltip>
    </b-table-column>
    <b-table-column :label="$t('attributes.product_name')" v-slot="props">
      <b-input
        :ref="`name-input-${props.row.code}`"
        type="textarea"
        rows="2"
        v-show="props.row.editing"
        v-model="props.row.nameValue"
        @keypress.enter.exact.native.prevent="
          finish(props.row, props.index + 1)
        "
        @keypress.enter.shift.exact.native.prevent="
          finish(props.row, props.index - 1)
        "
        @keydown.esc.exact.native.prevent="cancel(props.row)"
        @input="value => changeName(props.row, value)"
      />
      <div
        v-show="!props.row.editing"
        v-html="props.row.name"
        @click.meta="editing(props.row)"
        @click.shift="editing(props.row)"
      ></div>
    </b-table-column>
    <b-table-column
      width="120"
      :label="$t('attributes.function')"
      centered
      v-slot="props"
    >
      <div class="buttons is-centered">
        <b-button
          v-if="!props.row.editing"
          type="is-info"
          icon-left="pencil"
          @click.prevent="editing(props.row)"
        >
        </b-button>
        <b-tooltip :label="$t('attributes.restore')">
          <b-button
            v-if="!props.row.editing"
            type="is-info"
            icon-left="restore"
            outlined
            @click.prevent="restore(props.row)"
          >
          </b-button>
        </b-tooltip>
        <b-button
          v-if="props.row.editing"
          type="is-success"
          icon-left="check"
          @click.prevent="finish(props.row)"
        >
        </b-button>
        <b-button
          v-if="props.row.editing"
          type="is-dark"
          icon-left="close"
          outlined
          @click.prevent="cancel(props.row)"
        >
        </b-button>
      </div>
    </b-table-column>

    <template #empty>
      <section class="section" style="height: 100%">
        <div v-if="!loading" class="content has-text-grey has-text-centered">
          <p>
            <b-icon icon="emoticon-sad" size="is-large" />
          </p>
        </div>
      </section>
    </template>
  </b-table>
</template>

<script>
export default {
  name: 'ProductBatchNameTable',

  props: {
    products: {
      Type: Array,
      required: true
    },
    height: Number,
    loading: Boolean
  },
  data() {
    return {
      items: this.extractProducts(this.products)
    }
  },
  watch: {
    products(list) {
      this.items = this.extractProducts(list)
    }
  },
  methods: {
    extractProducts(products) {
      return products.map(product => ({
        code: product.code,
        nameValue: product.name,
        name: product.name,
        editing: false,
        dirty: false,
        error: null,
        origin: product
      }))
    },
    changeName(product, name) {
      product.nameValue = name.replace(/\n/g, '')
    },
    editing(product) {
      setTimeout(() => {
        const textarea = this.$refs[`name-input-${product.code}`].getElement()
        if (textarea) {
          textarea.selectionStart = 0
          textarea.selectionEnd = 0
          textarea.focus()
        }
      }, 0)

      product.editing = true
    },
    finish(product, next) {
      product.name = product.nameValue
      product.dirty = product.origin.name !== product.name
      product.editing = false

      this.validate(product)

      let index = (next + this.items.length) % this.items.length
      if (index >= 0 && index < this.items.length) {
        const nextProduct = this.items[index]
        this.editing(nextProduct)
      }
    },
    cancel(product) {
      product.nameValue = product.name
      product.dirty = product.origin.name !== product.name
      product.editing = false
    },
    restore(product) {
      product.name = product.origin.name
      product.nameValue = product.origin.name
      product.dirty = false
      product.error = null
      product.editing = false
    },
    isDirty() {
      return this.items.filter(x => x.dirty).length > 0
    },
    isEditing() {
      return this.items.filter(x => x.editing).length > 0
    },
    isValidate() {
      for (const product of this.items) {
        if (!this.validate(product)) {
          return false
        }
      }

      return true
    },
    validate(product) {
      if (!product.name.trim()) {
        product.error = '名稱不可空白'
        return false
      }

      product.error = null
      return true
    },
    getData() {
      return this.items
        .filter(product => product.dirty)
        .map(product => ({
          code: product.code,
          name: product.name
        }))
    },
    rowClass(product) {
      if (product.error) {
        return 'has-background-danger-light'
      } else if (product.dirty) {
        return 'has-background-warning'
      } else {
        return null
      }
    }
  }
}
</script>
